import React from "react";
import ButtonStartIcon from "../../../../../button/ButtonStartIcon";
import { useSelector } from "react-redux";
import SelectMultipleField from "../../../../../FormControl/input/SelectMultipleField";

export const renderElementLC = (row, currentCurriculum) => {
  const elements = {}
  Object.keys(row.curriculumElements || {}).forEach((element) => {
    const mapElements = (key, value, children) => {
      const find = children?.find((child) => child._id === value.value)
      if (find) {
        elements[key] = find.name
        Object.keys(value?.children || {}).forEach((child) => {
          const el = find.elements?.find((c) => c.elementStructureId === child)
          if (el) {
            mapElements(child, value.children[child], el.children)
          }
        })
      }
    }
    mapElements(element, row.curriculumElements[element], currentCurriculum.elements?.children || [])
  })

  return elements
};

const RenderCurriculum = (currentCurriculum, lcs) => {
  const curriculumElements = [];
  const elements = {}
  if (currentCurriculum.elementsStructure) {
    elements[currentCurriculum.elementsStructure?._id] = {
      _id: currentCurriculum.elementsStructure?._id,
      key: currentCurriculum.elementsStructure?._id,
      label: currentCurriculum.elementsStructure?.name,
    }

    const mapElements = (child) => {
      elements[child._id] = {
        _id: child._id,
        key: child._id,
        label: child.name,
      }
      child?.children?.forEach((element) => {
        mapElements(element)
      })
    }

    currentCurriculum.elementsStructure?.children.forEach((child) => {
      mapElements(child)
    });
  }
  Object.keys(elements).forEach((key) => {
    curriculumElements.push(elements[key])
  })

  
  const groundLCS = lcs.map((row) => {
    const elements = renderElementLC(row, currentCurriculum)
    return {
      _id: row._id,
      ...elements,
    }
  });

  return curriculumElements?.map((item) => {
    const children = [];
    groundLCS.forEach((lc) => {
      if (lc[item._id]) {
        if (children.includes(lc[item._id])) {
          return;
        }
        children.push(lc[item._id]);
      }
    }
    );

    return {
      _id: item._id,
      label: item.label,
      children: children?.map((item) => ({
        key: item,
        value: item,
        label: item,
      })),
    };
    }
  );
};

const Filter = ({ filter, onFilter, lcs }) => {
  const studentsLoading = useSelector(
    (state) => state?.classMarking?.studentsLoading
  );
  const currentCurriculum = useSelector(
    (state) => state?.assessment?.currentCurriculum || {}
  );

  const lcElements = currentCurriculum?.lcElements?.children
    ?.sort((a, b) => a.position - b.position)
    ?.map((item) => {
      const children = [];
      const child = {};

      lcs
        .filter((lc) => (lc?.lcElements ? lc?.lcElements?.[item._id] : false))
        .forEach((lc) => {
          if (child[lc?.lcElements?.[item._id]]) {
            child[lc?.lcElements?.[item._id]] = [
              lc._id,
              ...child[lc?.lcElements?.[item._id]],
            ];
          } else {
            child[lc?.lcElements?.[item._id]] = [lc._id];
          }
        });

      Object.keys(child).forEach((key) => {
        children.push({
          key: item._id,
          value: key,
          label: key,
          lcs: child[key],
        });
      });
      children.unshift({
        value: "",
        label: "Select all",
        lcs: children.map((item) => item.lcs).flat(),
      });

      return {
        _id: item._id,
        label: item.name,
        children,
      };
    });
  
  const curriculumElements = RenderCurriculum(currentCurriculum, lcs)

  return (
    <div className="flex items-center gap-2 h-14">
      <div className="left-0px sticky bg-background z-1">
        <ButtonStartIcon
          variant="text"
          startIcon="bars-filter"
          title="Filter"
          color="primary"
          classNameIcon="text-3xl"
          size="large"
        >
          Filter
        </ButtonStartIcon>
      </div>
      <div className="flex items-center gap-2">
        {curriculumElements?.map((lc, index) => (
          <div key={`curriculum-elements-${lc._id}-${index}`} className="max-w-150px min-w-150px">
            <SelectMultipleField
              id={lc._id}
              placeholder={lc.label}
              value={filter?.curriculumelements?.[lc._id]}
              options={lc.children}
              onChange={(e) => onFilter("curriculumelements", lc._id, e.target.value)}
              isLoading={studentsLoading}
            />
          </div>
        ))}
        {lcElements?.map((lc, index) => (
          <div key={`lc-elements-${lc._id}-${index}`} className="max-w-150px min-w-150px">
            <SelectMultipleField
              id={lc._id}
              placeholder={lc.label}
              value={filter?.lcElements?.[lc._id]}
              options={lc.children}
              onChange={(e) => onFilter("lcElements", lc._id, e.target.value)}
              isLoading={studentsLoading}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Filter;
